export default __webpack_public_path__ + "static/media/D_11880_COM_MANUAL.df74ce2d.png";